module.exports = __webpack_public_path__ + "img/36.e8cb1b5b.png";